// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1P7du","productName":"Table_productName__3fccC"};